import type { TMessages } from '@/types/TMessages'

export const messages = { loadMoreDefaultText: 'Показать еще' } satisfies TMessages
